import React, { useState, useEffect } from 'react'
import {Tabs, Menu} from 'tinper-bee'
import Layout from '../Layout'
import './index.css'
import * as util from '../../utils';
import Basic from './basic';
import OssInfo from './OssInfo';
import consoleIcon from '../../images/consoleIcon.png';
import PkgList from './pkg';
const TabPane = Tabs.TabPane;
class Console extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            activeKey: [],
            selectedKeys: ['0'],
            tenantList: [],
        };
    }


    componentDidMount() {
        if(!window.localStorage.user) {
            this.props.history.push('./skill-market')
        }
    }

    menuClick(e) {
        this.setState({
            selectedKeys: [e.key]
        })
    }
    onTabClick(e){

    }
    render() {
        const { user = {}, selectedKeys } = this.state;
        const title = ['基本信息','物料管理']
        return (
            <div className='console-wrapper'>
                <div className='left-menu'>
                    <div className='left-menu-top'>
                        <img src={consoleIcon} />
                        控制台
                    </div>
                    <Menu
                        onClick={(e) => this.menuClick(e)}
                        selectedKeys={this.state.selectedKeys}
                    >
                        <Menu.Item className='console-menu-item' key='0'>基本信息</Menu.Item>
                        <Menu.Item className='console-menu-item' key='1'>物料管理</Menu.Item>
                        {/*<Menu.Item className='console-menu-item' key='3'>OSS资源查询</Menu.Item>*/}
                        {/*<Menu.Item className='console-menu-item' key='3'>OSS资源查询</Menu.Item>*/}
                        {/*<Menu.Item key='3'>组件注册</Menu.Item>*/}
                    </Menu>
                </div>
                <div className='right-content'>
                    <div className='right-content-top'>
                        <div className='title'>{title[+selectedKeys[0]]}</div>
                    </div>
                    <div>
                        {
                            [
                                <Basic/>,
                                <PkgList tenantList={this.state.tenantList}/>,
                                // <OssInfo tenantList={this.state.tenantList} />
                            ][+selectedKeys[0]]
                        }
                    </div>

                </div>
            </div>
        )
    }
}
export default Layout(Console, 'console-page')
